import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  Inject,
  OnInit,
  OnDestroy,
  PLATFORM_ID,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { TopHeaderComponent } from '../buyer/buyer-core/buyer-layout/components/top-header/top-header.component';
import { BuyerHeaderComponent } from '../buyer/buyer-core/buyer-layout/components/buyer-header/buyer-header.component';
import { BuyerFooterComponent } from 'src/app/Shared/components/buyer-footer/buyer-footer.component';
import {
  distinctUntilChanged,
  filter,
  fromEvent,
  Subject,
  Subscription,
  takeUntil,
  tap,
} from 'rxjs';
import { isPlatformBrowser, Location, LocationStrategy, PlatformLocation } from '@angular/common';
import { ErrorStateService } from 'src/app/Shared/_services/error-state/error-state.service';
import { InlineErrorStatusComponent } from 'src/app/Shared/components/inline-error-status/inline-error-status.component';
import {
  isEmpty,
} from 'src/app/_utlis/language/language-helper';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
import { LanguageService } from 'src/app/Shared/services/language/language.service';
import { TranslationUpdater } from 'src/app/Shared/helpers/translation-updater';

import { TranslateService as NgxTranslateService } from '@ngx-translate/core';
import {
  NavigationEnd,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { ToolboxComponent } from 'src/app/Shared/components/toolbox/toolbox.component';
import { ProfileService } from '../buyer/buyer-modules/buyer-profile/_services/profile.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
import { BuyerAuthService } from '../buyer/buyer-core/buyer-authentication/services/buyer-auth/buyer-auth.service';
import { JqueryInitService } from 'src/app/Core/_services/jquery/jquery-init.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatIconButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import {
  MatFormField,
  MatError,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { LogoComponent } from 'src/app/Shared/components/logo/logo.component';
import { BuyerService } from '../buyer/_services/buyer/buyer.service';
import { emailValidator } from 'src/app/_utlis/app-validators';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { SellerAuthService } from '../seller/seller-core/_services/auth/auth.service';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import { CommunicationPreferencesPopupComponent } from '../../Shared/components/communication-preferences-popup/communication-preferences-popup.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { TranslateService } from 'src/app/Shared/services/translate/translate.service';
import { BrowserCheckService } from 'src/app/Shared/_services/browser-check/browser-check.service';
import { PopStateService } from 'src/app/Shared/_services/global-modal/pop-state.service';
import { LocaleLinkPipe } from 'src/app/Shared/_pipes/locale-link/locale-link.pipe';
import { LanguageNavigationService } from 'src/app/Core/locale/language-navigation.service';
export interface MenuItem {
  icon: string;
  label: string;
  route?: string;
  notifications?: number;
  active?: boolean;
  subMenu?: MenuItem[];
}
@Component({
    selector: 'app-public-layout',
        standalone: true,
imports: [
    TopHeaderComponent,
    BuyerFooterComponent,
    BuyerHeaderComponent,
    RouterOutlet,
    ToolboxComponent,
    MatCard,
    MatCardContent,
    LogoComponent,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatError,
    MatIconButton,
    MatSuffix,
    MatIcon,
    RouterLink,
    TranslatePipe,
    InlineErrorStatusComponent,
    LocaleLinkPipe
],
    templateUrl: './public-layout.component.html',
    styleUrl: './public-layout.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class PublicLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  isBrowser: boolean;
  profileImg!: string;
  userName: string = '';
  isLoggedIn = false;
  isBuyer = false;
  loginSub$!: Subscription;
  profileSub$!: Subscription;
  currentLang!: any;
  showLogin!: boolean;
  formData!: FormGroup;
  loginClicked!: boolean;
  isSellerLoggedIn: boolean = false;
  isHasPendingCommunicationPreferences: boolean = false;
  CommunicationPreferences: any;
  dialogRef!: MatDialogRef<CommunicationPreferencesPopupComponent, any>;
  private popStateListener?: (event: PopStateEvent) => void;
  private isDialogOpen = false;
  private isRootRoute = false;
  private hasInitialHistoryEntry = false;
  private dialogCompletedThisSession = false;
  private translationUpdater?: TranslationUpdater;
  private destroy$ = new Subject<void>();
  private initAllTimer: ReturnType<typeof setTimeout> | null = null;
  private routeInitTimer: ReturnType<typeof setTimeout> | null = null;

  // Error state signal for inline error display
  errorState = this.errorStateService.error;
  constructor(
    private translate: TranslateService,
    private ngxTranslate: NgxTranslateService,
    private languageService: LanguageService,
    private profileService: ProfileService,
    private storage: StorageService,
    private router: Router,
    private generalAuth: AuthService,
    private auth: BuyerAuthService,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: any,
    private jqueryInitService: JqueryInitService,
    private fb: FormBuilder,
    private buyerService: BuyerService,
    private toastService: ToastService,
    private buyerAuth: BuyerAuthService,
    private sellerAuth: SellerAuthService,
    private pusherService: PusherService,
    private dialog: MatDialog,
    private location: Location,
    private locationStrategy: LocationStrategy,
    private renderer: Renderer2,
    private browserService: BrowserCheckService,
    private platformLocation: PlatformLocation,
    private browserBackState: PopStateService,
    public localeService: LocaleService,
    private errorStateService: ErrorStateService,
    private languageNavigationService: LanguageNavigationService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    if (this.isBrowser) {
      // Add this to monitor route changes
      this.router.events
        .pipe(
          filter(
            (event): event is NavigationEnd => event instanceof NavigationEnd
          ),
          takeUntil(this.destroy$)
        )
        .subscribe((event: NavigationEnd) => {
          const currentRoute = event.urlAfterRedirects || event.url;
          this.isRootRoute =
            currentRoute === '/' ||
            currentRoute === '' ||
            currentRoute.endsWith('/');

          // Create initial history entry for root route if needed
          if (this.isRootRoute && !this.hasInitialHistoryEntry) {
            this.browserBackState.createInitialHistoryEntry('/');
            this.hasInitialHistoryEntry = true;
          }
        });
    }
    // Prevent back button navigation
    this.initForm();
  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.isRootRoute =
        this.router.url === '/' ||
        this.router.url === '' ||
        this.router.url.endsWith('/');

      if (this.isRootRoute && !this.hasInitialHistoryEntry) {
        this.browserBackState.createInitialHistoryEntry('/');
        this.hasInitialHistoryEntry = true;
      }

      this.currentLang = JSON.parse(
        localStorage.getItem(this.storage.getPrefixedKey('selectedLang')) ?? '{}'
      );

      this.buyerService.showLogin$
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          if (!res) {
            this.formData.reset();
            if (this.isBrowser) {
              document.body.style.overflow = '';
            }
          } else {
            if (this.isBrowser) {
              document.body.style.overflow = 'hidden';
            }
          }
          this.showLogin = res;
        });
      this.isLoggedIn = this.auth.isLoggedInAndAuthorized();
      this.isSellerLoggedIn = this.sellerAuth?.isAuthorized();
      this.loginSub$ = this.auth.loggedIn_authorized$
        .pipe(
          takeUntil(this.destroy$),
          distinctUntilChanged(),
          tap((isLoggedIn) => {
            this.isLoggedIn = isLoggedIn;
            this.userName = this.storage?.userData?.name || '';
            this.isBuyer = this.storage?.userData?.is_buyer;
            this.profileImg = this.storage?.userData?.profile_picture || '';
            this.isHasPendingCommunicationPreferences =
              this.storage?.userData?.has_pending_communication_preferences;
            this.CommunicationPreferences =
              this.storage?.userData?.communicationPreferences;

            if (
              isLoggedIn &&
              this.isHasPendingCommunicationPreferences &&
              !this.dialogCompletedThisSession && // Don't reopen if completed this session
              !this.isDialogOpen
            ) {
              setTimeout(() => {
                this.openCommunicationPreferencesDialog();
              }, 100);
            }

            this.cdr.markForCheck();
          })
        )
        .subscribe();

      // Also subscribe to profile changes
      this.profileSub$ = this.profileService.userDataChanged$
        .pipe(takeUntil(this.destroy$))
        .subscribe((userData) => {
          if (userData) {
            this.profileImg =
              userData.profile_picture ||
              this.storage?.userData?.profile_picture;
            this.userName = userData.name || this.storage?.userData?.name;
            this.isBuyer =
              userData.is_buyer !== undefined
                ? userData.is_buyer
                : this.storage?.userData?.is_buyer;
            this.isLoggedIn = true;
          }
          this.cdr.markForCheck();
        });

      // Setup auto-updating translations for menu items
      this.translationUpdater = new TranslationUpdater(
        this.languageService,
        () => this.updateMenuItems()
      );
    }
  }

  /**
   * Update menu items with current translations
   * Called automatically when language changes
   */
  updateMenuItems(): void {
    this.menuItems = [
      {
        icon: '',
        label: this.languageService.instant('buyer_header.my_auctions'),
        route: '/buyer/account/my-auctions',
        active: true,
      },
      { icon: '', label: this.languageService.instant('buyer_header.my_horses'), route: '/buyer/account/my-horses' },
      {
        icon: '',
        label: this.languageService.instant('buyer_header.my_offers'),
        route: '/offers',
        subMenu: [
          { icon: '', label: this.languageService.instant('buyer_header.my_offers'), route: '/buyer/account/my-offers' },
          { icon: '', label: this.languageService.instant('buyer_header.offers_hiistory'), route: '/buyer/account/offers-history' },
        ],
      },
      { icon: '', label: this.languageService.instant('buyer_header.my_bids'), route: '/buyer/account/my-bids' },
      { icon: '', label: this.languageService.instant('buyer_header.short_list'), route: '/buyer/account/wishlist' },
    ];
  }

  /**
   * Replace your existing openCommunicationPreferencesDialog method with this enhanced version
   */
  openCommunicationPreferencesDialog(): void {
    if (!this.isBrowser || this.isDialogOpen) return;

    this.isDialogOpen = true;

    // Set up back button prevention if on root route
    if (this.isRootRoute) {
      this.browserBackState.setupRootRouteBackPrevention('/');

      // Create additional history entry specifically for dialog
      history.pushState(
        {
          dialogOpen: true,
          preventBack: true,
          isRootEntry: true,
          dialogType: 'communication-preferences',
        },
        '',
        '/#communication-preferences'
      );
    }

    this.dialogRef = this.dialog.open(CommunicationPreferencesPopupComponent, {
      width: '600px',
      disableClose: true,
      closeOnNavigation: false, // Prevent closing on navigation
      panelClass: ['buyer-theme'],
      data: {
        CommunicationPreferences: this.CommunicationPreferences,
      },
    });

    this.dialogRef.afterClosed().subscribe((res: any) => {
      this.isDialogOpen = false;
      this.dialogCompletedThisSession = true;
      this.browserBackState.cleanupDialogNavigation('/');
    });
  }

  // Menu items - initialized in updateMenuItems() method
  menuItems: MenuItem[] = [];
  selectedTheme: 'green' | 'purple' | 'elegant' | 'modern' = 'green';

  // Handle click outside to close menu
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // This will be handled by the menu component internally
  }

  onMenuItemSelected(item: MenuItem) {
    if (item.route) {
      this.router.navigateByUrl(
        this.languageNavigationService.toLocalizedUrl(item.route)
      );
    }
  }

  handleSignOut() {
    this.generalAuth.logout();
  }

  // Example method to change the theme
  changeTheme(theme: 'green' | 'purple' | 'elegant' | 'modern') {
    this.selectedTheme = theme;
  }
  ngAfterViewInit() {
    // Small delay to ensure DOM is fully rendered
    this.initAllTimer = setTimeout(() => {
      this.jqueryInitService.cleanup();
      this.jqueryInitService.initAll(this.localeService.dir);
      // Or initialize only what you need
      // this.jqueryInitService.initButtonHoverEffects();
    });
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        if (this.routeInitTimer) {
          clearTimeout(this.routeInitTimer);
        }

        this.routeInitTimer = setTimeout(() => {
          this.jqueryInitService.cleanup();
          this.jqueryInitService.initAll(this.localeService.dir);
        }, 0);
      });
  }
  initForm() {
    this.formData = this.fb.group({
      email: new FormControl(
        '',
        Validators.compose([Validators.required, emailValidator])
      ),
      password: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  onSubmit() {
    this.toastService.clear();

    if (this.formData.valid) {
      this.loginClicked = true;
      // this.isLoading = true;
      this.buyerAuth.login(this.formData.value).subscribe({
        next: (response: { data: { token: string; user: any } }) => {
          const { user, token } = response.data;

          if (!user.email_verified_at) {
            this.router.navigate(['/buyer/auth/verify-email'], {
              queryParams: { email: user.email },
            });
          } else {
            this.storage.userToken = token;
            this.storage.userData = JSON.stringify(user);
            this.buyerAuth.setLoggedIn_authorized(true);
            this.loginClicked = false;
            this.pusherService.updateAuthToken(token);

            this.closePopUp();
            this.cdr.detectChanges();
          }
        },
        error: (error) => {
          this.loginClicked = false;

          this.toastService.showError(error?.error?.Error[0]);
        },
      });
    }
  }
  closePopUp() {
    this.loginClicked = false;
    if (this.isBrowser) {
      document.body.style.overflow = 'auto';
    }

    this.buyerService.setShowLogin(false);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    if (this.initAllTimer) {
      clearTimeout(this.initAllTimer);
      this.initAllTimer = null;
    }

    if (this.routeInitTimer) {
      clearTimeout(this.routeInitTimer);
      this.routeInitTimer = null;
    }

    // Cleanup translation updater
    if (this.translationUpdater) {
      this.translationUpdater.destroy();
    }

    // Cleanup existing subscriptions
    if (this.loginSub$) {
      this.loginSub$.unsubscribe();
    }
    if (this.profileSub$) {
      this.profileSub$.unsubscribe();
    }

    // Cleanup popstate listener
    if (this.popStateListener && this.isBrowser) {
      window.removeEventListener('popstate', this.popStateListener);
    }

    this.jqueryInitService.cleanup();
  }
}
